<script lang="ts">
	import Patron from '$lib/components/Patron.svelte'
	import Player from '$lib/components/Player.svelte'

	export let data
</script>

<svelte:head>
	<title>Scenery</title>
</svelte:head>

<section class="grid grid-cols-sm 2xl:grid-cols-lg gap-5 py-0 px-5">
	<Patron />
	{#each data.items as item (item.public_id)}
		<Player {...item} />
	{/each}
</section>
